var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_vm._t("default"):[_c('div',{staticClass:"d-flex align-center justify-center flex-column",staticStyle:{"min-height":"400px","height":"100%"}},[_c('v-progress-circular',{attrs:{"indeterminate":""}}),_c('div',{staticClass:"mt-12"},[_vm._t("loadingText")],2)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }